<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-xmla-subscription-level-dialog-form">
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Subscription Type</mat-label>
      <mat-select
        name="data.subscriptionTypeId"
        [(ngModel)]="data.subscriptionTypeId"
      >
        <mat-option
          *ngFor="let subTypes of data.xmlaSubscriptionTypes"
          [value]="subTypes.xmlaSubscriptionTypeId"
          >{{ subTypes.xmlaSubscriptionName }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Subscription Type</mat-label>
      <div>
        <ng-container *ngFor="let subTypes of data.xmlaSubscriptionTypes">
          <ng-container
            *ngIf="subTypes.xmlaSubscriptionTypeId == data.subscriptionTypeId"
          >
            {{ subTypes.xmlaSubscriptionName }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field>
      <mat-label>Description</mat-label>
      <input
        matInput
        name="data.description"
        [(ngModel)]="data.description"
      /> </mat-form-field
    ><br />
    <ng-container>
      <mat-checkbox name="data.allowInvoice" [(ngModel)]="data.allowInvoice"
        >Allow Invoice?</mat-checkbox
      > </ng-container
    ><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Subscription Level
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
